import { IppicaScommesseEsitoTipoBox, IppicaScommesseEsitoTipoBoxMinMax } from '../../ippicaScommesseEsitoTipoBox';
import { isQuotaFissa, isTotalizzatore } from 'features/ippica/functions';
import {
  selectBlockIppicaScommessa,
  selectCurrentScommesseType,
  selectHeadersQuotaFissaList,
  selectKeyListQuotaFissa,
  selectKeyListQuoteMinMax,
  selectKeyListQuoteTotalizzatore,
  selectKeyListQuoteVincenti,
  selectQuoteMinMaxList,
  selectTipoScommessaKey,
} from 'features/ippica/selectors';

import { BlockScommessa } from 'features/ippica/settings/settings-types';
import { DynamicIppicaScommesseCampiList } from '../../ippicaScommesseCampiList/IppicaScommesseCampiList';
import React from 'react';
import { Size } from 'features/ippica/types';
import styles from './IppicaScommesseEsitoRenderer.module.scss';
import { useHasCampiActive } from 'features/ippica/hooks';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaScommesseEsitoRendererProps = {
  keyCavallo: string;
  indexCavallo: number;
};
export const IppicaScommesseEsitoRenderer = ({ keyCavallo, indexCavallo }: IppicaScommesseEsitoRendererProps) => {
  // global
  const currentTypeScommessa = useTypedSelector(selectCurrentScommesseType);
  const blockScommessa = useTypedSelector(selectBlockIppicaScommessa);
  // quota fissa
  const quoteKeyListQuotaFissa = useTypedSelector(selectKeyListQuotaFissa(keyCavallo));
  const headerQuotaFissaList = useTypedSelector(selectHeadersQuotaFissaList);

  // quote totalizzatore
  const quoteKeyListTotalizzatore = useTypedSelector(selectKeyListQuoteTotalizzatore(keyCavallo));
  const tipoScommessaSelected = useTypedSelector(selectTipoScommessaKey);
  const quoteKeyListVincente = useTypedSelector(selectKeyListQuoteVincenti(quoteKeyListTotalizzatore));
  const quoteKeyListMinMax = useTypedSelector(selectKeyListQuoteMinMax(keyCavallo)); //retrieveKeyListQuoteMinMax(quoteKeyListTotalizzatore);
  const quotaMinMaxList = useTypedSelector(selectQuoteMinMaxList(quoteKeyListMinMax, keyCavallo));
  const hasCampiActive = useHasCampiActive(tipoScommessaSelected);
  const { isMobile } = useWindowSize();

  const isTypeScommessaQuotaFissa = currentTypeScommessa && isQuotaFissa(currentTypeScommessa);
  return (
    <React.Fragment>
      {/* QUOTA FISSA */}
      {isTypeScommessaQuotaFissa &&
        (blockScommessa === BlockScommessa.VincentePiazzato
          ? quoteKeyListQuotaFissa.map((keyQuota, indexQuota) => (
              <IppicaScommesseEsitoTipoBox
                key={keyQuota}
                keyCavallo={keyCavallo}
                keyQuota={keyQuota}
                label={headerQuotaFissaList?.[indexQuota]?.label}
              />
            ))
          : isTypeScommessaQuotaFissa && (
              <DynamicIppicaScommesseCampiList
                containerClassName={styles.wrapperCampi}
                size={Size.Large}
                keyCavallo={keyCavallo}
                indexCavallo={indexCavallo}
              />
            ))}
      {/* QUOTE TOTALIZZATORE */}
      {currentTypeScommessa && isTotalizzatore(currentTypeScommessa) ? (
        <>
          {isMobile &&
            (!hasCampiActive ? (
              <IppicaScommesseEsitoTipoBox
                keyCavallo={keyCavallo}
                keyQuota={quoteKeyListVincente?.[0]}
                label={'quota Vincente'} // TODO : CMS
              />
            ) : null)}
          {isMobile &&
            (!hasCampiActive ? (
              <IppicaScommesseEsitoTipoBoxMinMax
                label={'quota Min/Max'} // TODO : CMS
                keyCavallo={keyCavallo}
                quotaCombinataStatica={quotaMinMaxList?.[0]?.quota ?? ''}
              />
            ) : null)}
          {!isMobile && (
            <IppicaScommesseEsitoTipoBox
              keyCavallo={keyCavallo}
              keyQuota={quoteKeyListVincente?.[0]}
              label={'quota Vincente'} // TODO : CMS
            />
          )}

          {!isMobile && (
            <IppicaScommesseEsitoTipoBoxMinMax
              label={'quota Min/Max'} // TODO : CMS
              keyCavallo={keyCavallo}
              quoteKeyListMinMax={quoteKeyListTotalizzatore.slice(1)}
              quotaCombinataStatica={quotaMinMaxList?.[0]?.quota ?? ''}
            />
          )}

          {hasCampiActive && (
            <DynamicIppicaScommesseCampiList
              containerClassName={styles.wrapperCampi}
              size={Size.Large}
              keyCavallo={keyCavallo}
              indexCavallo={indexCavallo}
            />
          )}
        </>
      ) : null}
    </React.Fragment>
  );
};
